import { render } from "./refund_record.vue?vue&type=template&id=2cab36a0&scoped=true"
import script from "./refund_record.vue?vue&type=script&lang=js"
export * from "./refund_record.vue?vue&type=script&lang=js"

import "./refund_record.vue?vue&type=style&index=0&id=2cab36a0&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cab36a0"]])

export default __exports__